module.exports = __webpack_public_path__ + "img/d5694e0785cbbd9byy2b29965c0c5887.d1b7008b.png";